import RestoreIcon from "@mui/icons-material/Restore";
import {
	Button,
	useDataProvider,
	useNotify,
	useRecordContext,
	useRefresh,
} from "react-admin";
import type { AdminDataProvider } from "@/providers/dataProvider";

interface RestoreButtonProps {
	resource: string;
}

export const RestoreButton = ({ resource }: RestoreButtonProps) => {
	const record = useRecordContext();
	const dataProvider = useDataProvider<AdminDataProvider>();
	const refresh = useRefresh();
	const notify = useNotify();

	if (!record || !record.deletedAt) {
		return null;
	}

	const handleClick = async () => {
		try {
			await dataProvider.restore(resource, record.id);
			notify("Record restored successfully", { type: "success" });
			refresh();
		} catch (error) {
			notify(
				error instanceof Error ? error.message : "Failed to restore record",
				{ type: "error" },
			);
		}
	};

	return (
		<Button
			label="Restore"
			onClick={handleClick}
			startIcon={<RestoreIcon />}
			color="primary"
		/>
	);
};
